const fragment = `
  id
  name
  state
  description
  longDescription
  defaultImageUrl 
  lastModifiedLog {
    id
    initialValue
    finalValue
    maker {
      id
      name
      role
    }
  }
  creator {
    id
    name
    role
  }
`;

export const listCitiesQuery = `
  query ListCities(
    $filter: CityFilterInput
  ) {
    items: listCities(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getCityQuery = `
  query GetCity($id: Int!) {
    item: getCity(id: $id) {
      ${fragment}
    }
  }
`;

export const createCityQuery = `
  mutation CreateCity(
    $input: CreateCityInput!
  ) {
    item: createCity(input: $input) {
      ${fragment}
    }
  }
`;

export const updateCityQuery = `
  mutation UpdateCity(
    $input: UpdateCityInput!
  ) {
    item: updateCity(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteCityQuery = `
  mutation DeleteCity(
    $id: Int!
  ) {
    item: deleteCity(id: $id) {
      ${fragment}
    }
  }
`;
